import { createSelector } from 'reselect';

const getDoctors = (state: any) => state.getIn(['doctors', 'get']);

const mapDoctor = (doctor: any) => ({
  location: {
    latitude: doctor.coordinates[1],
    longitude: doctor.coordinates[0],
  },
  specialities: doctor.specialities,
  photo: doctor.photo,
  fullName: doctor.full_name,
  rating: doctor.rating,
  profileUrl: doctor.profile_url,
  address: doctor.address_neighborhood,
  phoneNumber: doctor.phone_number,
  hasOnlineAgenda: doctor.has_online_agenda,
});

export const getDoctorsSelector = createSelector(
  getDoctors,
  ({ data, ...rest }) => ({
    ...rest,
    data: data?.map(mapDoctor),
  }),
);
